// ** Third Party Components
import styled, { css } from "styled-components";

export const StyledSvgIconContainer = styled.span`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 18px;
	margin: 0 0.5rem 0 0;

	${({ $customMargin }) =>
		$customMargin &&
		css`
			margin: ${$customMargin};
		`}

	${({ $customWidth }) =>
		$customWidth &&
		css`
			width: ${$customWidth};
		`}

	svg {
		fill: ${({ theme: { colors } }) => colors.whiteAlways};
		display: block;
		height: 1em;

		${({ $customHeight }) =>
			$customHeight &&
			css`
				height: ${$customHeight};
			`};

		${({ $customVerticalAlign }) =>
			$customVerticalAlign &&
			css`
				vertical-align: ${$customVerticalAlign};
			`};
	}
`;
const SexIcon = ({
	customHeight,
	customMargin,
	customVerticalAlign,
	customWidth,
}) => {
	return (
		<StyledSvgIconContainer
			$customHeight={customHeight}
			$customMargin={customMargin}
			$customVerticalAlign={customVerticalAlign}
			$customWidth={customWidth}
		>
			<svg
				viewBox="0 0 16 14"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M14.4278 7.89414C13.275 7.89414 12.775 8.7582 12.1472 8.7582C10.4833 8.75547 12 3.9375 12 3.9375C12 3.9375 6.54722 6.125 6.54722 3.84727C6.54722 2.86836 7.55556 2.58125 7.55556 1.4957C7.55556 0.525 6.775 0 5.84722 0C4.88333 0 4.00278 0.516797 4.00278 1.53945C4.00278 2.67148 4.88333 3.16094 4.88333 3.77617C4.88611 5.6793 0 4.56094 0 4.56094V13.6719C0 13.6719 4.96111 14.793 4.96111 12.8871C4.96111 12.2719 3.85 11.7906 3.85 10.6586C3.85 9.6332 4.66389 9.11914 5.61667 9.11914C6.55278 9.11914 7.33333 9.64414 7.33333 10.6148C7.33333 11.7004 6.325 11.9875 6.325 12.9664C6.325 14.6289 9.92778 13.6691 11.3583 13.6691C11.3583 13.6691 10.3944 10.3852 12.075 10.3852C13.075 10.3852 13.3639 11.375 14.4722 11.375C15.4639 11.375 16 10.6094 16 9.69063C16 8.75547 15.4722 7.89141 14.4278 7.89141V7.89414Z"
					fill="#AC0DFC"
				/>
			</svg>
		</StyledSvgIconContainer>
	);
};

export default SexIcon;
